export class DrugAdminRouteModel {
    route_abbrev: string
    route_note: string

    constructor(route_abbrev: string, route_note: string) {
        this.route_abbrev = route_abbrev
        this.route_note = route_note
    }
}